export const stripePaymentTypes = {
  CARD: 'card',
  PAYPAL: 'paypal',
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
};
